import { Spaceoq5xo9lsieqc as Space } from '../views/direct/Space.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../views/NativeElement.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { removeSuffix3d61x5lsuvuho as removeSuffix } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Regexxgw0gjiagf4z as Regex } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_camelRegex() {
  _init_properties_Page_kt__j5c6s1();
  return camelRegex;
}
var camelRegex;
var EmptyClass;
function Empty() {
  if (EmptyClass === VOID) {
    class $ {
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (Space())(_this__u8e3s4.get_context_h02k06_k$());
        ensureOutermostElement(element);
        _this__u8e3s4.willAddChild_hz2iwc_k$(element);
        element.onStartup_vrxh3i_k$();
        _this__u8e3s4.addChild_2qpft2_k$(element);
      }
    }
    protoOf($).get_title_iz32un_k$ = get_title;
    initMetadataForObject($, 'Empty', VOID, VOID, [Page()]);
    EmptyClass = $;
  }
  return EmptyClass;
}
var Empty_instance;
function Empty_getInstance() {
  return Empty_instance;
}
var DirectClass;
function Direct() {
  if (DirectClass === VOID) {
    class $ {
      constructor(title, render) {
        title = title === VOID ? '' : title;
        this.render_1 = render;
        this.title_1 = new (Constant())(_Constant___init__impl__v45mub(title));
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        return this.render_1(_this__u8e3s4);
      }
      get_title_iz32un_k$() {
        return this.title_1;
      }
    }
    initMetadataForClass($, 'Direct', VOID, VOID, [Page()]);
    DirectClass = $;
  }
  return DirectClass;
}
function get_title() {
  var tmp0_elvis_lhs = getKClassFromExpression(this).get_simpleName_r6f8py_k$();
  return new (Constant())(_Constant___init__impl__v45mub(removeSuffix(removeSuffix(camelToHuman(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs), ' Screen'), ' Page')));
}
var PageClass;
function Page() {
  if (PageClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Page');
    PageClass = $;
  }
  return PageClass;
}
function camelToHuman(_this__u8e3s4) {
  _init_properties_Page_kt__j5c6s1();
  var tmp2 = get_camelRegex();
  // Inline function 'kotlin.text.replace' call
  var transform = camelToHuman$lambda;
  return tmp2.replace_dbivij_k$(_this__u8e3s4, transform);
}
function camelToHuman$lambda(it) {
  _init_properties_Page_kt__j5c6s1();
  return it.get_groupValues_rkv314_k$().get_c1px32_k$(1) + ' ' + it.get_groupValues_rkv314_k$().get_c1px32_k$(2);
}
var properties_initialized_Page_kt_aanf75;
function _init_properties_Page_kt__j5c6s1() {
  if (!properties_initialized_Page_kt_aanf75) {
    properties_initialized_Page_kt_aanf75 = true;
    camelRegex = Regex().new_kotlin_text_Regex_acuq4a_k$('([a-z])([A-Z]+)');
  }
}
//region block: init
Empty_instance = new (Empty())();
//endregion
//region block: exports
export {
  Direct as Direct1onk7bpgb7kpa,
  get_title as get_titlelss9nf4gv6ut,
  Page as Page1o437w9xuocrm,
  Empty_instance as Empty_instancerdfpp8xjdvlo,
};
//endregion

//# sourceMappingURL=Page.mjs.map
